import { Card, createStyles, Select } from "@mantine/core";
import MapView from "components/Dashboard/mapView";
import StatsGrid from "components/Dashboard/StatGrid";
import { useState } from "react";
import SalesDashboard from "components/Dashboard/report";
import SupplierDashboard from "components/SupplierDashboard/report";
import SupplierStatsGrid from "components/SupplierDashboard/StatGrid";
import { showNotification } from "@mantine/notifications";
import { useQuery } from "@apollo/client";
import { ADMIN_DASHBOARD, SUPPLIER_DASHBOARD } from "apollo/queries";
import { useEffect } from "react";
import { Flex } from "@mantine/core";
import OrdersBarChart from "components/SupplierDashboard/orderBarChart";

const DistributerIcon = {
  url: "https://img.icons8.com/external-flaticons-lineal-color-flat-icons/40/000000/external-distributor-sales-flaticons-lineal-color-flat-icons.png",
};

const RetailerIcon = {
  url: "https://img.icons8.com/external-filled-outline-wichaiwi/40/000000/external-Retailer-business-filled-outline-wichaiwi.png",
};

const WarehouseIcon = {
  url: "https://img.icons8.com/external-xnimrodx-lineal-color-xnimrodx/40/000000/external-warehouse-distribution-xnimrodx-lineal-color-xnimrodx-2.png",
};

const dataDashboard = [
  {
    title: "Total Orders",
    icon: "receipt",
    value: "",
    diff: 34,
  },
  {
    title: "Total Sales",
    icon: "discount",
    value: "",
    diff: 18,
  },
  {
    title: "Total Active Orders",
    icon: "user",
    value: "188",
    diff: -6,
  },
];

const useStyles = createStyles((theme) => ({
  userStatusWrapper: {
    flex: 1,
    marginLeft: theme.spacing.md,
  },
}));

const Dashboard = () => {
  const [timeRange, setTimeRange] = useState("YEARLY");
  const { classes } = useStyles();
  const [selectedBadge, setSelectedBadge] = useState(5);

  const roles = JSON.parse(localStorage.getItem("roles")) || [];
  const [value, setValue] = useState(null);
  const hasSupplierPermission = roles.some(
    (permission) => permission === "supplier"
  );
  const handleChange = (value) => {
    setValue(value);
  };

  const {
    data: supplierData,
    loading: supplierLoading,
    refetch: supplierRefetch,
  } = useQuery(SUPPLIER_DASHBOARD, {
    variables: {
      period_type: timeRange,
      limit: selectedBadge,
    },
    skip: !hasSupplierPermission,
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message ||
          "Failed to get supplier dashboard",
      });
    },
  });

  const {
    data: adminData,
    loading: adminLoading,
    refetch: adminRefetch,
  } = useQuery(ADMIN_DASHBOARD, {
    variables: {
      period_type: timeRange,
      limit: selectedBadge,
    },
    skip: hasSupplierPermission,
    onError(error) {
      showNotification({
        color: "red",
        title: "Error",
        message:
          error?.graphQLErrors?.[0]?.message || "Failed to get admin dashboard",
      });
    },
  });

  useEffect(() => {
    if (hasSupplierPermission) {
      supplierRefetch({ period_type: timeRange, limit: selectedBadge });
    } else {
      adminRefetch({ period_type: timeRange, limit: selectedBadge });
    }
  }, [
    timeRange,
    hasSupplierPermission,
    supplierRefetch,
    adminRefetch,
    selectedBadge,
  ]);
  return (
    <div style={{}}>
      {!hasSupplierPermission ? (
        <>
          <StatsGrid
            data={adminData?.getAdminDashboard}
            loading={adminLoading}
            timeRange={timeRange}
            onTimeRangeChange={setTimeRange}
          />
          <SalesDashboard
            selectedBadge={selectedBadge}
            setSelectedBadge={setSelectedBadge}
            loading={adminLoading}
            data={adminData?.getAdminDashboard}
          />
          <div style={{ width: "96%", marginLeft: 40 }}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ marginRight: "15px" }}>
                <img
                  src={RetailerIcon.url}
                  alt="Retailer"
                  style={{ width: "24px", verticalAlign: "middle" }}
                />
                <span style={{ marginLeft: "5px" }}>Retailer</span>
              </div>
              <div style={{ marginRight: "15px" }}>
                <img
                  src={DistributerIcon.url}
                  alt="Distributor"
                  style={{ width: "24px", verticalAlign: "middle" }}
                />
                <span style={{ marginLeft: "5px" }}>Distributor</span>
              </div>
              <div style={{ marginRight: "15px" }}>
                <img
                  src={WarehouseIcon.url}
                  alt="Warehouse"
                  style={{ width: "24px", verticalAlign: "middle" }}
                />
                <span style={{ marginLeft: "5px" }}>Warehouse</span>
              </div>
              <Select
                placeholder="Pick value"
                data={["Distributor", "Warehouse", "Retailer"]}
                value={value}
                onChange={handleChange}
                clearable
                style={{ width: 200 }}
              />
            </div>
            <Card shadow="sm" p="lg">
              <MapView value={value} />
            </Card>
          </div>
        </>
      ) : (
        <>
          <SupplierStatsGrid
            loading={supplierLoading}
            datas={dataDashboard}
            data={supplierData?.supplierDashboard}
            timeRange={timeRange}
            onTimeRangeChange={setTimeRange}
          />
          <SupplierDashboard
            selectedBadge={selectedBadge}
            setSelectedBadge={setSelectedBadge}
            data={supplierData?.supplierDashboard}
          />
          <OrdersBarChart
            data={supplierData?.supplierDashboard?.orders_bar_chart}
          />
        </>
      )}
    </div>
  );
};

export default Dashboard;
